import { RatingGoalCalculator } from "./RatingGoalCalculator";
import { CurrentSentimentCard } from "./CurrentSentimentCard";
import { LatestReviewCard } from "./LatestReviewCard";
import { Review, SentimentDataPoint } from "@/types/index";

interface ReviewCardsRowProps {
  currentAverage: number;
  totalReviews: number;
  sentimentData: SentimentDataPoint[];
  latestReview: Review | null;
  onViewDetails?: (review: Review) => void;
}

export function ReviewCardsRow({
  currentAverage,
  totalReviews,
  sentimentData,
  latestReview,
  onViewDetails
}: ReviewCardsRowProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <LatestReviewCard review={latestReview} onViewDetails={onViewDetails} />
      <CurrentSentimentCard
        sentimentData={sentimentData}
        totalReviews={totalReviews}
      />
      <RatingGoalCalculator
        currentAverage={currentAverage}
        totalReviews={totalReviews}
      />
    </div>
  );
}
